<template>
  <footer class="footer-wrapper ff-primary">
    <div class="footer">
      <div class="footer-body">
        <div class="footer-widget footer-identity">
          <div class="logo-and-social-media">
            <img
              alt="Karier.mu"
              class="kariermu-footer-logo"
              src="https://cdn.karier.mu/kariermu/assets/logo/kariermu-2023.webp"
            />
            <div class="icon-social-wrapper">
              <a
                v-for="(social, iSocial) in socialMediaLists"
                :id="`social-media-${iSocial}`"
                :key="iSocial"
                :href="social.href"
                class="socials-icon"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img :alt="`${social.name} Karier.mu`" :src="social.icon" class="social-icon" loading="lazy" />
              </a>
            </div>
          </div>
          <div class="google-play-download">
            <p class="m-0 fs-18 fw-600 fl-24">Download Our App</p>
            <a
              id="icon-store-device"
              href="https://play.google.com/store/apps/details?id=mu.karier.android&hl=in"
              rel="noopener"
              target="_blank"
            >
              <img
                alt="Karier.mu at Google Play Store"
                class="google-play-store-logo"
                src="https://cdn.karier.mu/kariermu/2023/assets/download-android.webp"
              />
            </a>
          </div>
        </div>
        <div class="footer-link-details">
          <div class="footer-widget about-us">
            <h4 class="footer-menu-title fs-18 fw-600 fl-24">About Us</h4>
            <div class="footer-submenu">
              <router-link id="profile-page" to="/profil-kariermu">
                <div class="footer-menu-submenu inter-medium-normal fl-25">About Karier.mu</div>
              </router-link>
              <!-- Hide for now -->
              <!-- <a :href="`${kariermuAppUrl}/dewan-kariermu${query}`">-->
              <!--  <div class="footer-menu-submenu inter-medium-normal fl-25">Dewan Karier.mu</div>-->
              <!-- </a>-->
              <a id="career-page" :href="redirectionKarier" target="_blank">
                <div class="footer-menu-submenu inter-medium-normal fl-25">Career</div>
              </a>
            </div>
          </div>
          <div class="footer-widget about-prakerja">
            <h4 class="footer-menu-title fs-18 fw-600 fl-24">About Prakerja</h4>
            <div class="footer-submenu">
              <a id="mitra-microsite" href="https://www.karier.mu/mitra-kolaborasi">
                <div class="footer-menu-submenu inter-medium-normal fl-25">Become Our Partners</div>
              </a>
              <a id="faq" href="https://www.karier.mu/faq/help/prakerja/" target="_blank">
                <div class="footer-menu-submenu inter-medium-normal fl-25">Prakerja Guide</div>
              </a>
            </div>
          </div>
          <div class="footer-widget our-products">
            <h4 class="footer-menu-title fs-18 fw-600 fl-24">Our Products</h4>
            <div class="footer-submenu">
              <a
                id="kariermu-for-business-link"
                class="d-block text-decoration-none"
                href="https://www.karier.mu/business/?utm_source=kariermu&utm_medium=navigation-bar-for-business"
              >
                <div class="footer-menu-submenu inter-medium-normal fl-25">Karier.mu for Business</div>
              </a>
              <a
                id="kariermu-for-talent-link"
                class="d-block text-decoration-none"
                href="https://www.karier.mu/talent/"
              >
                <div class="footer-menu-submenu inter-medium-normal fl-25">Karier.mu for Talent</div>
              </a>
              <a
                id="kariermu-prakerja-link"
                target="_blank"
                href="https://www.prakerja.karier.mu/"
              >
                <div class="footer-menu-submenu inter-medium-normal fl-25">Karier.mu Prakerja</div>
              </a>
            </div>
          </div>
          <div class="footer-widget help">
            <h4 class="footer-menu-title fs-18 fw-600 fl-24">Help</h4>
            <div class="footer-submenu">
              <a
                id="help-page"
                :href="envBelajar ? 'https://karier.mu/faq' : 'https://www.karier.mu/faq/help/prakerja/'"
                rel="noopener noreferrer"
                target="_blank"
              >
                <div class="footer-menu-submenu inter-medium-normal fl-25">Help Center</div>
              </a>
              <a
                id="blog-page"
                href="https://karier.mu/blog"
                rel="noopener noreferrer"
                target="_blank"
              >
                <div class="footer-menu-submenu inter-medium-normal fl-25">Blog</div>
              </a>
              <router-link id="contact-page" to="/kontak-kariermu">
                <div class="footer-menu-submenu inter-medium-normal fl-25">Contact Us</div>
              </router-link>
            </div>
          </div>
          <div class="footer-widget others">
            <h4 class="footer-menu-title fs-18 fw-600 fl-24">Others</h4>
            <div class="footer-submenu">
              <router-link id="privacy-policy-page" to="/kebijakan-privasi">
                <div class="footer-menu-submenu inter-medium-normal fl-25">Privacy Policy</div>
              </router-link>
              <router-link id="tos-page" to="/syarat-ketentuan">
                <div class="footer-menu-submenu inter-medium-normal fl-25">Terms of Service</div>
              </router-link>
              <a
                v-if="!isPrakerja"
                id="governance-page"
                class="d-block text-decoration-none"
                :href="`${kariermuRewriteURL}/governance`"
              >
                <div class="footer-menu-submenu inter-medium-normal fl-25">Governance</div>
              </a>
            </div>
          </div>
          <div class="footer-widget security">
            <h4 class="footer-menu-title fs-18 fw-600 fl-24">Security</h4>
            <div class="img-wrapper">
              <img
                alt="ISO/IEC 27001"
                class="iso-logo"
                src="https://cdn.karier.mu/kariermu/2023/assets/iso-logo.webp"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright text-gargoyle fs-12 fw-600 fl-16">© {{ currentYear }} Karier.mu. PT Semesta Integrasi Digital. All Rights Reserved.</div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState(['isPrakerja']),
    kariermuRewriteURL () {
      return this.isPrakerja ? process.env.VUE_APP_PRAKERJA_URL : process.env.VUE_APP_URL_REWRITE
    },
    socialMediaLists () {
      const { isPrakerja } = this.$store.state
      const defaultLists = [{
        name: 'YouTube',
        href: 'https://www.youtube.com/c/Kariermu',
        icon: 'https://cdn.karier.mu/kariermu/2023/assets/youtube.svg'
      }, {
        name: 'Instagram',
        href: 'https://www.instagram.com/kariermu/',
        icon: 'https://cdn.karier.mu/kariermu/2023/assets/instagram.svg'
      }, {
        name: 'Facebook',
        href: 'https://m.facebook.com/kariermuid/',
        icon: 'https://cdn.karier.mu/kariermu/2023/assets/facebook.svg'
      }, {
        name: 'Tiktok',
        href: 'https://www.tiktok.com/@kariermu_official',
        icon: 'https://cdn.karier.mu/assets/v3/icon/tiktok-logo.svg'
      }, {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/kariermuid/',
        icon: 'https://cdn.karier.mu/kariermu/2023/assets/linkedin.svg'
      }]

      return defaultLists.map(socialMedia => {
        if (isPrakerja && socialMedia.name === 'Instagram') {
          return { ...socialMedia, href: 'https://www.instagram.com/kariermuprakerja/' }
        }
        return socialMedia
      })
    },
    cdnEnv () {
      return process.env.VUE_APP_CDN_ENV
    },
    envBelajar () {
      return this.$store.state.envBelajar
    },
    redirectionKarier () {
      let redirectionLink = ''
      this.envBelajar
        ? redirectionLink = 'https://jobs.talentics.id/sekolahmu?utm_source=kariermu&utm_medium=footer&utm_campaign=karier-talentics'
        : redirectionLink = 'https://jobs.talentics.id/sekolahmu?utm_source=prakerja&utm_medium=footer&utm_campaign=karier-talentics'

      return redirectionLink
    },
    currentYear () {
      return new Date().getFullYear().toString()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  padding-top: 34px;
  padding-bottom: 60px;
  background-color: var(--color-background-white);
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  background-image: url("https://cdn.karier.mu/kariermu/2023/assets/bg-mweb.svg");
}

.footer-body {
  width: 100%;
  max-width: 1140px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.footer-widget {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
}

.footer-identity {
  align-items: center;
  gap: 40px;
}

.kariermu-footer-logo {
  width: 100%;
  max-width: 200px;
  height: 32px;
}

.google-play-store-logo {
  width: 100%;
  max-width: 105px;
  height: auto;
}

.iso-logo {
  width: 100%;
  max-width: 54px;
  height: auto;
}

.social-icon {
  width: 32.2px;
  height: auto;
}

.follow-us {
  width: 100%;
  margin-bottom: 16px;
}

.footer-menu-title {
  color: var(--color-text-primary);
  margin-bottom: 16px;
}

.footer-menu-submenu {
  color: var(--color-text-secondary-2);
  margin-bottom: 12px;
}

.footer-menu-submenu:hover,
a:hover {
  text-decoration: none;
  color: var(--color-royal-navy-500);
}

.img-wrapper {
  display: block;
  margin-bottom: 33.7px;
}

.logo-and-social-media {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.copyright {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 10px;
  height: 48px;
  background-color: var(--color-neutral-100);
}

.icon-social-wrapper {
  display: flex;
  gap: 12px;
}

.google-play-download {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

@media only screen and (min-width: 768px) {
  .footer {
    padding-top: 48px;
    background-image: url("https://cdn.karier.mu/kariermu/2023/assets/bg-web.svg");
  }

  .footer-body {
    width: 100%;
    max-width: 1140px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .footer-link-details {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    column-gap: 98px;
    row-gap: 24.13px;
    width: 100%;
    max-width: 796px;
  }

  .footer-widget {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    text-align: left;
    margin-bottom: 0;
  }

  .google-play-store-logo {
    width: 100%;
    max-width: 148px;
    margin-bottom: 0;
  }

  .footer-identity {
    display: flex;
    flex-direction: column;
    gap: 66.98px;
    width: 100%;
    max-width: 240.5px;
  }

  .follow-us {
    padding-right: 25px;
    min-width: 210px;
  }

  .kariermu-footer-logo {
    max-width: 189px;
    margin-bottom: 32px;
  }

  .logo-and-social-media {
    gap: 0;
  }

  .google-play-download {
    align-items: flex-start;
  }
}
</style>
